import {
    customGetProductCollectionRealTimeInventory,
    getSelectedWarehouse,
} from "@crescentParts/Services/SelectedWarehouseInventoryService";
import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { GetProductCollectionRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection, getShouldLoadInventory } from "@insite/client-framework/Store/Context/ContextSelectors";
import { RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

const myListsDetailsPath = "/myaccount/mylists/details";
const pageQueryStringKey = "page";
const myListDetailsPageQueryStringValue = "mylistdetails";

type Parameter = GetProductCollectionRealTimeInventoryApiV2Parameter &
    HasOnSuccess<RealTimeInventoryModel> &
    HasOnError<unknown>;

type Props = {
    apiParameter: GetProductCollectionRealTimeInventoryApiV2Parameter;
    apiResult: RealTimeInventoryModel;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiWithSelectedWarehouse: HandlerType = async props => {
    const { productSettings, websiteSettings } = getSettingsCollection(props.getState());
    const selectedWarehouse = getSelectedWarehouse(props.getState());
    const hasWarehouseExpand = props.apiParameter.expand?.includes("warehouses");

    if (!productSettings.showInventoryAvailability) {
        return;
    }

    if (!getShouldLoadInventory(props.getState())) {
        props.dispatch({ type: "Context/AddDeferredApiCall", deferredCallType: "inventory" });
        return false;
    }

    if (typeof window !== "undefined" && window.location.pathname.toLowerCase().includes(myListsDetailsPath)) {
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters ?? {}),
            [pageQueryStringKey]:
                props.apiParameter.additionalQueryStringParameters?.[pageQueryStringKey] ?? myListDetailsPageQueryStringValue,
        };
    }

    if (selectedWarehouse && !hasWarehouseExpand) {
        props.apiParameter.additionalQueryStringParameters = {
            ...(props.apiParameter.additionalQueryStringParameters ?? {}),
            selectedWarehouse,
        };
    }

    try {
        props.apiResult = await customGetProductCollectionRealTimeInventory(props.apiParameter);
    } catch (error) {
        logger.warn(`Failed to load inventory data: ${error}`);
        props.error = error;
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiWithSelectedWarehouse);
